import React from "react";
import { observer } from "mobx-react";
import { DashboardLayoutTemplateUpdateStore } from "../../store";
import { DashboardLayoutTemplateUpdateForm } from "./DashboardLayoutTemplateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type DashboardLayoutTemplateUpdateProps = {
  dashboardLayoutTemplateUpdateStore: DashboardLayoutTemplateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const DashboardLayoutTemplateUpdate: React.FC<DashboardLayoutTemplateUpdateProps> =
  observer(
    ({
      dashboardLayoutTemplateUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={dashboardLayoutTemplateUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={dashboardLayoutTemplateUpdateStore.savedButOutdated}
            onReload={() =>
              dashboardLayoutTemplateUpdateStore.reloadDashboardLayoutTemplate()
            }
            reloadDisabled={dashboardLayoutTemplateUpdateStore.isProcessing}
          />
          <DashboardLayoutTemplateUpdateForm
            dashboardLayoutTemplateUpdateStore={
              dashboardLayoutTemplateUpdateStore
            }
            nameError={dashboardLayoutTemplateUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              dashboardLayoutTemplateUpdateStore.setNameValue(value);
            }}
            name={dashboardLayoutTemplateUpdateStore.entityValues.name}
            forRoleError={
              dashboardLayoutTemplateUpdateStore.errors.forRole?.message
            }
            onForRoleChange={(value: string) => {
              dashboardLayoutTemplateUpdateStore.setForRoleValue(value);
            }}
            forRole={dashboardLayoutTemplateUpdateStore.entityValues.forRole}
            widgetsError={
              dashboardLayoutTemplateUpdateStore.errors.widgets?.message
            }
            onWidgetsChange={(value: string) => {
              dashboardLayoutTemplateUpdateStore.setWidgetsValue(value);
            }}
            widgets={dashboardLayoutTemplateUpdateStore.entityValues.widgets}
            isDefaultError={
              dashboardLayoutTemplateUpdateStore.errors.isDefault?.message
            }
            onIsDefaultChange={(value: boolean) => {
              dashboardLayoutTemplateUpdateStore.setIsDefaultValue(value);
            }}
            isDefault={
              dashboardLayoutTemplateUpdateStore.entityValues.isDefault
            }
            enabledError={
              dashboardLayoutTemplateUpdateStore.errors.enabled?.message
            }
            onEnabledChange={(value: boolean) => {
              dashboardLayoutTemplateUpdateStore.setEnabledValue(value);
            }}
            enabled={dashboardLayoutTemplateUpdateStore.entityValues.enabled}
            isForAllTenantsError={
              dashboardLayoutTemplateUpdateStore.errors.isForAllTenants?.message
            }
            onIsForAllTenantsChange={(value: boolean) => {
              dashboardLayoutTemplateUpdateStore.setIsForAllTenantsValue(value);
            }}
            isForAllTenants={
              dashboardLayoutTemplateUpdateStore.entityValues.isForAllTenants
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={dashboardLayoutTemplateUpdateStore.saveDisabled}
            onSave={() =>
              dashboardLayoutTemplateUpdateStore.saveDashboardLayoutTemplate()
            }
            onCancel={() =>
              dashboardLayoutTemplateUpdateStore.cancelDashboardLayoutTemplate()
            }
          />
          <ErrorDialog
            open={dashboardLayoutTemplateUpdateStore.errorDialogOpened}
            title={dashboardLayoutTemplateUpdateStore.errorTitle}
            description={dashboardLayoutTemplateUpdateStore.errorDescription}
            onClose={() =>
              dashboardLayoutTemplateUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={dashboardLayoutTemplateUpdateStore.confirmDialogOpened}
            title={dashboardLayoutTemplateUpdateStore.confirmDialogTitle}
            description={
              dashboardLayoutTemplateUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              dashboardLayoutTemplateUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              dashboardLayoutTemplateUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
